"use client"
import { useMemo } from "react"
import { useHudContext, useHudDates } from "../../shared/playbookHUDInfra"
import { getPoliciesByStatusForDate } from "./policiesData"

// Which policies sit in each status section for the currently animated HUD
// date. The CSV-sourced timeline transitions at trimester boundaries, so
// memoize at day-precision (cheap; rare actual recomputes).
export const useGroupedPoliciesForActiveDate = () => {
  const { animatedDate } = useHudDates()
  const dateKey = animatedDate.toISOString().slice(0, 10)
  return useMemo(
    () => getPoliciesByStatusForDate(new Date(`${dateKey}T00:00:00Z`)),
    [dateKey],
  )
}
